var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-card', [_c('b-tabs', {
    attrs: {
      "pills": "",
      "horizontal": _vm.windowWidth < 768,
      "vertical": _vm.windowWidth > 768,
      "nav-wrapper-class": _vm.windowWidth > 768 ? 'w-25' : 'w-100',
      "fill": ""
    }
  }, [_c('Cliente'), _c('Servicos'), _c('Faturamento'), _c('Informacoes')], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm.canSaveOrcamento ? _c('div', [_c('div', {
    staticClass: "form mb-5"
  }, [_vm.store.currentTab !== 0 ? _c('button', {
    staticClass: "btn btn-secondary font-weight-bold mr-2",
    on: {
      "click": _vm.handlePrevious
    }
  }, [_vm._v(" Anterior ")]) : _vm._e(), _vm.store.isUpdate && _vm.store.currentTab !== 3 ? _c('button', {
    staticClass: "btn btn-primary font-weight-bold mr-4",
    on: {
      "click": _vm.handleNext
    }
  }, [_vm._v(" Proximo ")]) : _vm._e(), _c('button', {
    ref: "submit_contrato_servicos",
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": _vm.salvarContratoServicos
    }
  }, [_vm._v(" Salvar ")]), _c('button', {
    staticClass: "btn btn-clean font-weight-bold",
    on: {
      "click": function click($event) {
        return _vm.confirmCancel('contratosServicos');
      }
    }
  }, [_vm._v(" Cancelar ")])])]) : _c('div', [_c('button', {
    staticClass: "btn btn-secondary font-weight-bold mr-4",
    attrs: {
      "disabled": _vm.store.currentTab === 0
    },
    on: {
      "click": _vm.handlePrevious
    }
  }, [_vm._v(" Anterior ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": _vm.handleNext
    }
  }, [_vm._v(" Proximo ")]), _c('button', {
    staticClass: "btn btn-clean font-weight-bold",
    on: {
      "click": function click($event) {
        return _vm.confirmCancel('contratosServicos');
      }
    }
  }, [_vm._v(" Cancelar ")])])])])])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };